import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  background: ${({ theme }) => theme.color.white};
  border-radius: 12px;
  border: 1px solid ${({ theme }) => theme.color.grey300};
`;

export const DataWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  padding: 32px;
`;

export const DataSection = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;

  > div:first-of-type {
    border-right: 1px solid ${({ theme }) => theme.color.grey300};
  }

  h3 {
    font-family: Mulish;
    font-weight: 700;
    font-size: 18px;
    line-height: 25.2px;
  }
`;

export const Information = styled.div`
  display: flex;
  flex-direction: column;
  padding-right: 32px;
  gap: 24px;
`;

export const Metrics = styled.div`
  display: flex;
  flex-direction: column;
  padding-left: 32px;
  gap: 24px;
`;

export const MetricsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const EditorWrapper = styled.div`
  h3 {
    font-family: Mulish;
    font-weight: 500;
    font-size: 16px;
    line-height: 22px;
    color: ${({ theme }) => theme.color.grey600};
  }
`;

export const ButtonWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  width: 100%;
  margin-top: 16px;
  padding-top: 32px;
  border-top: 1px solid #d0d5dd;

  button {
    width: 150px;

    &:last-child {
      margin-left: 20px;
    }
  }
`;

export const EmptyMetrics = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  width: 100%;
  gap: 16px;
  font-weight: 600;
  font-size: 16px;
  color: ${({ theme }) => theme.color.grey600};
`;
